/**
 * <menu-flutuante> — dock do celular (sections/menu-flutuante.liquid).
 * Começa escondido. Aparece quando o cabeçalho some ao rolar para baixo (evento "header:scroll-hide"
 * de <site-header-bar>, assets/header.js) ou quando a página chega ao fim; some quando o cabeçalho
 * volta ("header:scroll-show"). Só age abaixo de 768px.
 * Publica --dock-height no <html>: altura do dock quando visível, 0px quando não.
 * Estado visual: atributo data-shown (CSS no bloco "Dock do celular" do theme.css).
 */
(function () {
  "use strict";

  if (customElements.get("menu-flutuante")) return;
  if (!window.EssenceBaseComponent) return;

  var MOBILE_QUERY = "(max-width: 767px)";
  var BOTTOM_GAP = 2; // px de folga para considerar "fim da página"

  class MenuFlutuante extends window.EssenceBaseComponent {
    get eagerInit() {
      return true;
    }

    init() {
      var signal = this.__tdController.signal;
      var self = this;

      this.media = window.matchMedia(MOBILE_QUERY);
      this.headerHidden = false;
      this.atBottom = false;
      this.editorPinned = false;
      this.ticking = false;

      document.addEventListener(
        "header:scroll-hide",
        function () {
          self.headerHidden = true;
          self.update();
        },
        { signal: signal }
      );
      document.addEventListener(
        "header:scroll-show",
        function () {
          self.headerHidden = false;
          self.update();
        },
        { signal: signal }
      );

      window.addEventListener(
        "scroll",
        function () {
          if (self.ticking) return;
          self.ticking = true;
          requestAnimationFrame(function () {
            self.ticking = false;
            self.update();
          });
        },
        { passive: true, signal: signal }
      );

      this.media.addEventListener("change", this.update.bind(this), { signal: signal });

      this.resizeObserver = new ResizeObserver(function () {
        self.publishHeight();
      });
      this.resizeObserver.observe(this);

      this.update();
    }

    isAtBottom() {
      var doc = document.documentElement;
      return window.innerHeight + window.scrollY >= doc.scrollHeight - BOTTOM_GAP;
    }

    update() {
      this.atBottom = this.isAtBottom();
      var visible = this.media.matches && (this.editorPinned || this.headerHidden || this.atBottom);
      if (visible === this.hasAttribute("data-shown")) return;
      this.toggleAttribute("data-shown", visible);
      this.inert = !visible;
      this.publishHeight();
    }

    publishHeight() {
      var height = this.hasAttribute("data-shown") ? Math.round(this.getBoundingClientRect().height) : 0;
      document.documentElement.style.setProperty("--dock-height", height + "px");
    }

    onEditorBlockSelect() {
      this.editorPinned = true;
      this.update();
    }

    onEditorBlockDeselect() {
      this.editorPinned = false;
      this.update();
    }

    destroy() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      document.documentElement.style.setProperty("--dock-height", "0px");
    }
  }

  customElements.define("menu-flutuante", MenuFlutuante);
})();
